module.exports = __webpack_public_path__ + "media/site_templates/www.furnituremovingservices.com.au/images/splash-3073bb20c49c9908f8fedd6f3bbc5c01.jpg";